export const HOME = {
  // Header
  navLogo: "nav-logo",
  navLinkProduct: "nav-link-product",
  navLinkWorkspace: "nav-link-workspace",
  navLinkPricing: "nav-link-pricing",
  navLinkDocs: "nav-link-docs",
  navCtaLogin: "nav-cta-login",
  navCtaStart: "nav-cta-start",

  // Hero
  heroEyebrow: "hero-eyebrow",
  heroHeadline: "hero-headline",
  heroSubheadline: "hero-subheadline",
  heroDescription: "hero-description",
  heroCtaPrimary: "hero-cta-primary",
  heroCtaSecondary: "hero-cta-secondary",
  heroTrustBar: "hero-trust-bar",
  heroDashboard: "hero-dashboard",
  heroMap: "hero-map",
  heroRightPanel: "hero-right-panel",
  heroMilestones: "hero-milestones",

  // Problem
  problemSection: "problem-section",

  // Why
  whySection: "why-section",
  whyCard: "why-card",

  // Dashboard
  dashboardSection: "dashboard-section",

  // Milestones
  milestoneSection: "milestone-section",
  milestoneStep: "milestone-step",

  // Alerts
  alertsSection: "alerts-section",
  alertCard: "alert-card",

  // Connected Workspace
  workspaceSection: "workspace-section",
  workspaceNode: "workspace-node",

  // Outcomes
  outcomesSection: "outcomes-section",
  outcomeCard: "outcome-card",

  // FAQ
  faqSection: "faq-section",
  faqItem: "faq-item",

  // Final CTA
  finalCta: "final-cta",
  finalCtaPrimary: "final-cta-primary",
  finalCtaSecondary: "final-cta-secondary",

  // Footer
  footer: "site-footer",

  // Legacy
  emergentLink: "emergent-link",
};
